import { Scale, Eye, TrendingUp } from "lucide-react";

const VALUES = [
    {
        icon: Scale,
        title: "Ética",
        desc: "Conduta íntegra em cada operação, contrato e relacionamento — pilar inegociável da nossa atuação.",
    },
    {
        icon: Eye,
        title: "Transparência",
        desc: "Indicadores, rotinas e ocorrências documentadas. O cliente acompanha de perto cada etapa.",
    },
    {
        icon: TrendingUp,
        title: "Melhoria Contínua",
        desc: "Processos revisados, equipe treinada e tecnologia aplicada para elevar o padrão a cada ciclo.",
    },
];

export default function QuemSomos() {
    return (
        <section
            id="quem-somos"
            data-testid="quem-somos-section"
            className="relative py-24 sm:py-32 border-t border-zinc-200 dark:border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-8">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-7">
                        <span className="inline-block text-xs font-bold uppercase tracking-[0.22em] text-[#E89546]">
                            Quem somos
                        </span>
                        <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-zinc-950 dark:text-white leading-tight">
                            Reputação construída no chão da operação.
                        </h2>
                        <p className="mt-6 text-zinc-700 dark:text-zinc-300 text-base sm:text-lg leading-relaxed">
                            A <span className="text-zinc-950 dark:text-white font-semibold">GOODMAX Gestão de Serviços</span> nasceu para entregar excelência operacional onde ela mais importa: no dia a dia. Atuamos com equipes qualificadas e processos estruturados, oferecendo soluções personalizadas que promovem segurança, organização e otimização de recursos para clientes dos setores público e privado.
                        </p>
                        <p className="mt-4 text-zinc-600 dark:text-zinc-400 leading-relaxed">
                            Com sede em Salvador-BA, atendemos contratantes de diferentes portes e segmentos — de condomínios e instituições de ensino a operações de mineração e infraestrutura — sempre com o mesmo compromisso: eficiência, resultado e atendimento ao cliente.
                        </p>

                        <div className="mt-10 grid sm:grid-cols-3 gap-4">
                            {VALUES.map(({ icon: Icon, title, desc }) => (
                                <div
                                    key={title}
                                    data-testid={`valor-${title.toLowerCase()}-card`}
                                    className="group rounded-2xl border border-zinc-200 dark:border-white/5 bg-white dark:bg-[#0d0d0d] p-6 hover:bg-zinc-50 dark:hover:bg-[#141414] hover:border-zinc-300 dark:hover:border-white/10 transition-colors shadow-sm dark:shadow-none"
                                >
                                    <div className="w-10 h-10 rounded-xl bg-[#E89546]/10 text-[#E89546] flex items-center justify-center">
                                        <Icon className="w-5 h-5" />
                                    </div>
                                    <h3 className="mt-4 font-heading text-lg font-bold text-zinc-950 dark:text-white">{title}</h3>
                                    <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400 leading-relaxed">{desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-5">
                        <div className="relative flex flex-col items-center lg:items-end">
                            <img
                                src="/goodmax-worker.png?v=2"
                                alt="Colaborador GOODMAX"
                                className="w-auto max-h-[520px] sm:max-h-[620px] object-contain drop-shadow-[0_25px_50px_rgba(0,0,0,0.45)]"
                            />
                            <div className="mt-6 max-w-md text-left lg:text-right">
                                <div className="text-xs uppercase tracking-[0.22em] text-[#2DA89E]">
                                    Nosso compromisso
                                </div>
                                <div className="mt-2 font-heading text-xl sm:text-2xl font-bold text-zinc-950 dark:text-white leading-tight">
                                    Segurança, organização e otimização — entregues com consistência.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
